var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextmessageicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.625C15.752 9.61483 15.5208 10.5912 15.075 11.475C14.5458 12.5338 13.7323 13.4244 12.7256 14.047C11.7189 14.6695 10.5587 14.9995 9.375 15C8.38516 15.002 7.40878 14.7708 6.525 14.325L2.25 15.75L3.675 11.475C3.22923 10.5912 2.99798 9.61483 3 8.625C3.00046 7.44132 3.33046 6.28114 3.95304 5.27441C4.57562 4.26768 5.46619 3.45417 6.525 2.925C7.40878 2.47923 8.38516 2.24798 9.375 2.25H9.75C11.3121 2.33948 12.7868 3.00035 13.8932 4.10676C14.9997 5.21317 15.6605 6.68785 15.75 8.25V8.625Z",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.75H12.75M6 9.75H10.5",
    strokeWidth: 1.35,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextmessageicon);
export default __webpack_public_path__ + "static/media/Text message icon.e77f9d8d5f2f10c2f13d28ef458ce18d.svg";
export { ForwardRef as ReactComponent };